import React, { FC } from "react";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { DeviceTimePattern } from "../../../models/DeviceTimePattern";
import { WizardSummaryLayout } from '../../../components/wizard/wizard-summary-layout';

interface WizardSummaryProps {
    onNext?: (event: any) => void | undefined;
    onBack?: (event: any) => void | undefined;
    selectedDeviceTimePattern: DeviceTimePattern;
    selectedMode: any
}

export const WizardSummary: FC<WizardSummaryProps> = ({ onNext = undefined, onBack = undefined, selectedDeviceTimePattern, selectedMode }) => {
    const { translate } = useLocale();

    return <WizardSummaryLayout onBack={onBack} submitLabel={translate.byKey(TranslationKeys.confirm)} onSubmit={onNext ? (e) => onNext(e) : undefined}>
        <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.mode)}: <span className="text-sm text-black">{selectedMode.name}</span></h4>
        <br />
        <h2 className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.activePeriod)}</h2>
        <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.timePattern)}: <span className="text-sm text-black">{selectedDeviceTimePattern.name}</span></h4>
        <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.startDate)}: <span className="text-sm text-black">{selectedDeviceTimePattern.startDate === "" ? '----' : selectedDeviceTimePattern.startDate}</span></h4>
        <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.endDate)}: <span className="text-sm text-black">{selectedDeviceTimePattern.endDate === "" ? '----' : selectedDeviceTimePattern.endDate}</span></h4>
        <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.startTime)}: <span className="text-sm text-black">{selectedDeviceTimePattern.startTime ?? '--:--'}</span></h4>
        <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.endTime)}: <span className="text-sm text-black">{selectedDeviceTimePattern.endTime ?? '--:--'}</span></h4>
        <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.days)}: <span className="text-sm text-black">{selectedDeviceTimePattern.days}</span></h4>
    </WizardSummaryLayout>;
};
